import type React from 'react';
import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination } from 'swiper/modules';
import type { Swiper as SwiperType } from 'swiper';
import { Attachment } from '../types';

// Import Swiper styles
import 'swiper/css';
import "swiper/css/effect-coverflow";
import 'swiper/css/pagination';

export default function ImageSwiper({ carouselItems, setSelectedImage }: {
  carouselItems: Attachment[],
  setSelectedImage: React.Dispatch<React.SetStateAction<string | null>>
}) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleSlideChange = (swiper: SwiperType) => {
    setCurrentIndex(swiper.activeIndex);
  };

  const handleImageClick = (imageUrl: string) => {
    setSelectedImage(imageUrl);
  };

  return (
    <div className={`${carouselItems.length > 1 ? 'pb-4' : 'pb-12'} w-full`}>
      <Swiper
        modules={[EffectCoverflow, Pagination]}
        spaceBetween={16}
        slidesPerView={"auto"}
        centeredSlides={true}
        onSlideChange={handleSlideChange}
        className="w-full h-auto"
        effect='coverflow'
        grabCursor={true}
        initialSlide={0}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 0,
          modifier: 2.5,
          slideShadows: false,
        }}
      >
        {carouselItems.map((item, index) => (
          <SwiperSlide key={index} className='w-[65%] max-w-[300px]'>
            <div className="w-full aspect-square max-h-[300px] overflow-hidden rounded-[32px]">
              <img
                src={item.url}
                alt={item.name}
                className="w-full h-full object-cover cursor-pointer"
                onClick={() => handleImageClick(item.url)}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Page Indicator */}
      {carouselItems.length > 1 && (
        <div className="pt-3 w-fit mx-auto">
          <span className="text-[#333] text-lg">
            {currentIndex + 1}/{carouselItems.length}
          </span>
        </div>
      )}
    </div>
  );
}
